export default __webpack_public_path__ + "static/media/EAST1070.34I-34196_-18441_0.017658b8.jpg";